import { constants } from 'utils/dateAndTimes';

const keyGenerator = {
  address: {
    pickup: ({ shipmentKey }) => `shipment_${shipmentKey}_address_pickup`,
    dropoff: ({ shipmentKey }) => `shipment_${shipmentKey}_address_dropoff`,
    zipcode: ({ shipmentKey, stopType }) =>
      `zipcode_${shipmentKey}_${stopType}`,
  },
  dateTime: ({ shipmentKey, dateTimeKey }) =>
    `shipment.${shipmentKey}.${dateTimeKey}`,
  shipmentData: {
    time: ({ stopType, timeParam }) => `${stopType}_time_${timeParam}`,
    date: ({ stopType, timeParam }) => `${stopType}_date_${timeParam}`,
  },
  time: {
    from: ({ shipmentKey, stopType }) =>
      `shipment.${shipmentKey}.${stopType}_${constants.TIME_FIELD_PARAMS.from}`,
    to: ({ shipmentKey, stopType }) =>
      `shipment.${shipmentKey}.${stopType}_${constants.TIME_FIELD_PARAMS.to}`,
  },
  date: ({ shipmentKey, stopType }) =>
    `shipment_${shipmentKey}_${stopType}_date`,
  load: ({ shipmentKey, loadKey, field }) =>
    `shipment_${shipmentKey}_loads_${loadKey}_${field}`,
  timestamp: () => new Date().getTime(),
  recurring: {
    range: () => `RECURRING_RANGE`,
    days: () => `RECURRING_DAYS`,
  },
  aditionalOptions: {
    pickup: ({ shipmentKey }) =>
      `shipment_${shipmentKey}_pickup_comment_from_shipper_to_driver`,
    dropoff: ({ shipmentKey }) =>
      `shipment_${shipmentKey}_dropoff_comment_from_shipper_to_driver`,
    internal: ({ shipmentKey }) => `shipment_${shipmentKey}_internal_reference`,
    appointment: ({ shipmentKey }) =>
      `shipment_${shipmentKey}_appointment_instructions`,
  },
  settings: {
    first_name: 'settings_first_name',
    last_name: 'settings_last_name',
  },
};

export default keyGenerator;
